import { Modal } from "bootstrap";
import { useEffect } from "react";

interface UseModalEffectResponsiveProps {
    modalIdPrimary: string;
    modalIdSecondary: string;
    showModalSeconday: boolean;
    setShowModalSecondary: (value: boolean) => void;
}

const useModalEffectResponsive = ({
    modalIdPrimary,
    modalIdSecondary,
    showModalSeconday,
    setShowModalSecondary,
}: UseModalEffectResponsiveProps) => {
    useEffect(() => {
        // 👉 Helper force cleanup untuk jaga-jaga
        const forceCleanupBody = () => {
            const openModals = document.querySelectorAll(".modal.show").length;
            if (openModals === 0) {
                document.body.classList.remove("modal-open");
                document.body.style.overflow = "auto";
                document.body.style.paddingRight = ""; // Bootstrap kadang menambah scrollbar padding
            }
        };
        if (showModalSeconday) {
            const modalSecondaryEl = document.getElementById(modalIdSecondary);
            const modalPrimaryEl = document.getElementById(modalIdPrimary);
            if (modalSecondaryEl && modalPrimaryEl) {
                const modalInstanceSecondary = new Modal(modalSecondaryEl);
                const modalInstancePrimary = new Modal(modalPrimaryEl);

                // Tampilkan modal secondary
                modalInstanceSecondary.show();

                // Saat secondary ditutup → show primary lagi
                const handleModalHide = () => {
                    setShowModalSecondary(false);
                    modalInstancePrimary.show();

                    // 🔍 Delay sedikit agar transisi backdrop selesai
                    setTimeout(() => {
                        forceCleanupBody();
                    }, 500); // Durasi fade Bootstrap default: 300ms~500ms
                };

                modalSecondaryEl.addEventListener("hidden.bs.modal", handleModalHide);

                return () => {
                    modalSecondaryEl.removeEventListener("hidden.bs.modal", handleModalHide);
                    // 🧹 Pastikan cleanup juga saat unmount
                    forceCleanupBody();
                };
            }
        }

        // 🧹 Jaga-jaga, kalau unmount hook-nya tanpa event tertembak
        return () => {
            forceCleanupBody();
        };
    }, [showModalSeconday, modalIdPrimary, modalIdSecondary, setShowModalSecondary]);
};

export default useModalEffectResponsive;
